module.exports = __webpack_public_path__ + "img/boxes_set.f9b75032.png";